module.exports = __webpack_public_path__ + "img/mobile-wallet-logo.a033e56b.png";